export default {"src":"/_next/static/media/exp.5946e4d5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};